import React, { useState, useEffect } from "react";
import {
  View,
  Text,
  Image,
  FlatList,
  TouchableOpacity,
  Clipboard,
  Share,
} from "react-native";
import { Base64 } from "js-base64";
import {
  CreateResponsiveStyle,
  DEVICE_SIZES,
  useDeviceSize,
} from "rn-responsive-styles";
import { AppColors } from "../../utility/AppColors";
import { AppFontStyle } from "../../styles/AppFontStyle";
import { AppImages } from "../../utility/AppImages";
import {
  CommonActions,
  StackActions,
  useNavigation,
} from "@react-navigation/native";
import withErrorBoundary from "../../utility/auth/withErrorBoundary";
import { toast } from "react-toastify";
import { chatUrl } from "../../utility/Index";

const SocialMediaShare = ({
  arrSocialMedia,
  username,
  marginVertical = 30,
  btnMarginBottom = 50,
}) => {
  const styles = useStyles();
  const navigation = useNavigation();

  const [link, setLink] = useState(chatUrl);

  useEffect(() => {
    if (username) {
      const queryParams = {
        username: username,
        type: "single",
      };

      const encodedParams = Base64.encode(JSON.stringify(queryParams));
      setLink(`${chatUrl}?session=${encodedParams}`);
    }
  }, [username]);

  const handleCopyLink = () => {
    Clipboard.setString(link);
    toast.success("Link copied to clipboard!");
  };

  const handleShare = async (item) => {
    try {
      await Share.share({
        message: `Join the chat with me: ${link}`,
        url: link,
        title: "Shared Link",
      });
    } catch (error) {
      alert(error.message);
    }
  };

  const shareOnWhatsApp = () => {
    const url = link;
    window.open(`https://wa.me/?text=${encodeURIComponent(url)}`, "_blank");
  };

  const shareOnInstagram = () => {
    const url = link;
    window.open(
      `instagram://sharesheet?text=${encodeURIComponent(url)}`,
      "_blank"
    );
  };

  const shareOnTwitter = () => {
    const url = link;
    window.open(
      `https://twitter.com/intent/tweet?url=${encodeURIComponent(url)}`,
      "_blank"
    );
  };

  const shareOnFacebook = () => {
    const url = encodeURIComponent(link);
    const message = `Check out this link: ${url}`;
    const messengerLink = `https://www.messenger.com/t/?message=${encodeURIComponent(
      message
    )}`;
    window.open(messengerLink, "_blank");
  };

  return (
    <View
      style={[
        styles.mainView,
        {
          marginVertical: marginVertical,
        },
      ]}
    >
      <View style={{ gap: 35, flex: 1, marginHorizontal: 10 }}>
        <FlatList
          data={arrSocialMedia}
          numColumns={4}
          renderItem={({ item, index }) => {
            const handlePress = () => {
              switch (item.name) {
                case "Whatsapp":
                  shareOnWhatsApp();
                  break;
                case "Instagram":
                  shareOnInstagram();
                  break;
                case "Twitter":
                  shareOnTwitter();
                  break;
                case "Facebook":
                  shareOnFacebook();
                  break;
                default:
                  break;
              }
            };

            return (
              <TouchableOpacity
                key={index}
                style={{
                  flexDirection: "column",
                  width: "25%",
                  gap: 10,
                  marginVertical: 5,
                  justifyContent: "space-between",
                  alignItems: "center",
                }}
                activeOpacity={0.5}
                onPress={handlePress}
              >
                <Image
                  source={item.image}
                  style={{
                    height: 54,
                    width: 54,
                    resizeMode: "contain",
                  }}
                />
                <Text
                  style={[
                    AppFontStyle.MEDIUM_ANYBODY_10,
                    {
                      color: AppColors.white,
                      textAlign: "center",
                      paddingVertical: 5,
                    },
                  ]}
                >
                  {item.name}
                </Text>
              </TouchableOpacity>
            );
          }}
        />
      </View>
      <Text
        style={[
          AppFontStyle.REGULAR_ANYBODY_18,
          {
            color: AppColors.white,
            textAlign: "justify",
            lineHeight: 25,
            paddingVertical: 20,
          },
        ]}
      >
        Copy link
      </Text>
      <View style={styles.footerText}>
        <TouchableOpacity activeOpacity={0.5}>
          <Image
            source={AppImages.icLinkSocial}
            style={{ height: 20, width: 20, resizeMode: "contain" }}
          />
        </TouchableOpacity>
        <Text
          numberOfLines={4}
          style={{
            color: AppColors.white,
            paddingLeft: 10,
            flexShrink: 1,
            overflow: "hidden",
          }}
        >
          {link}
        </Text>
      </View>
      <View
        style={{
          height: 1,
          backgroundColor: AppColors.gray_1E1E1E,
          marginTop: 10,
        }}
      />
      <View
        style={{
          flexDirection: "row",
          columnGap: 20,
          paddingVertical: 25,
          paddingHorizontal: 10,
          marginBottom: btnMarginBottom,
        }}
      >
        <TouchableOpacity
          style={[
            styles.buttonStyle,
            {
              backgroundColor: "transparent",
              borderWidth: 1,
              borderColor: AppColors.white,
            },
          ]}
          activeOpacity={0.5}
          onPress={() => {
            // navigation.dispatch(StackActions.pop());
            navigation.dispatch(
              CommonActions.reset({
                index: 0,
                routes: [{ name: "ChatTabStack" }],
              })
            );
          }}
        >
          <Text
            style={[
              AppFontStyle.BOLD_ANYBODY_16,
              styles.buttonTextStyle,
              { color: AppColors.appViolentColor_6D08C3 },
            ]}
          >
            Back
          </Text>
        </TouchableOpacity>
        <TouchableOpacity
          style={styles.buttonStyle}
          activeOpacity={0.5}
          onPress={handleCopyLink}
        >
          <Text
            style={[
              AppFontStyle.BOLD_ANYBODY_16,
              styles.buttonTextStyle,
              { color: AppColors.white },
            ]}
          >
            Copy
          </Text>
        </TouchableOpacity>
      </View>
    </View>
  );
};

const useStyles = CreateResponsiveStyle(
  {
    mainView: {
      width: "35%",
      backgroundColor: AppColors.black_121212,
      borderRadius: 12,
      zIndex: -1,
    },
    footerText: {
      flexDirection: "row",
      backgroundColor: AppColors.appBlackColor_1e1e1e,
      paddingHorizontal: 16,
      paddingVertical: 16,
      borderRadius: 10,
      marginBottom: 20,
      gap: 5,
      alignItems: "center",
      flexWrap: "nowrap",
      overflow: "hidden",
    },
    buttonStyle: {
      flex: 1,
      backgroundColor: AppColors.appViolentColor_6D08C3,
      paddingHorizontal: 16,
      paddingVertical: 12,
      borderRadius: 12,
      justifyContent: "center",
      alignItems: "center",
    },
    buttonTextStyle: {
      fontSize: 16,
    },
  },
  {
    [DEVICE_SIZES.LG]: {
      mainView: {
        width: "50%",
      },
    },
    [DEVICE_SIZES.MD]: {
      mainView: {
        width: "70%",
      },
    },
    [DEVICE_SIZES.SM]: {
      mainView: {
        width: "70%",
      },
    },
    [DEVICE_SIZES.XS]: {
      mainView: {
        width: "100%",
      },
    },
  }
);

export default withErrorBoundary(SocialMediaShare);
